export default __webpack_public_path__ + "static/char-v-02-4a41e761d2955853506c5e12ba5fa895.png";